import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BuildingImagesRoutingModule } from './building-images-routing.module';
import { BuildingimagesLinkComponent } from './buildingimages-link/buildingimages-link.component';
import { BuildingImagesComponent } from './building-images/building-images.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BuildingImagesDialogComponent } from './building-images-dialog/building-images-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AgGridModule } from 'ag-grid-angular';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BuildingImagesDetialsComponent } from './building-images-detials/building-images-detials.component';


@NgModule({
  declarations: [
    BuildingimagesLinkComponent,
    BuildingImagesComponent,
    BuildingImagesDialogComponent,
    BuildingImagesDetialsComponent
  ],
  imports: [
    CommonModule,
    BuildingImagesRoutingModule,
    AcademicFormModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    BrowserAnimationsModule,
    FormsModule,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatDatepickerModule,
    MatInputModule,
    AgGridModule,
    GoogleMapsModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
  ]
})
export class BuildingImagesModule { }
